export const bestDoctors = [
  {
    "_id": "6875541b1d1c547428160cf7",
    "id": "aditya-ranjan",
    "name": "Aditya Ranjan",
    "specialty": "Cardiology",
    "experience": "20 Yrs of Development",
    "image": "https://res.cloudinary.com/drpnp4uzc/image/upload/v1752519626/medical-linkers/doctors/pbedtbd61w4uhgrvavud.jpg",
    "link": "/doctors/aditya-ranjan/",
    "description": "He is such a great doctor, What a doctor like OMG",
    "qualifications": [
      "B Tech",
      "AISSCE"
    ],
    "about": "He is such a great doctor, What a doctor like OMG",
    "hospital": "CohortLab",
    "country": "India",
    "categories": [
      "bestDoctors",
      "turkeyDoctors",
      "starDoctorsIndiaData",
      "starDoctorsTurkeyData"
    ],
    "isActive": true,
    "createdAt": "2025-07-14T19:01:47.642Z",
    "updatedAt": "2025-07-14T19:01:47.642Z",
    "__v": 0
  },
  {
    "_id": "6877e16264f4d8afea22ff65",
    "id": "ishan",
    "name": "Ishan",
    "specialty": "Cardiology",
    "experience": "20 Yrs of Development",
    "image": "https://res.cloudinary.com/drpnp4uzc/image/upload/v1752686941/medical-linkers/doctors/frwx4pioaxpkyyxrkuxm.jpg",
    "link": "/doctors/ishan/",
    "description": "very good doctor",
    "qualifications": [
      "B Tech",
      "AISSCE"
    ],
    "about": "actally very good doctor",
    "hospital": "CohortLab",
    "country": "India",
    "categories": [
      "bestDoctors",
      "turkeyDoctors",
      "starDoctorsIndiaData",
      "starDoctorsTurkeyData"
    ],
    "isActive": true,
    "createdAt": "2025-07-16T17:29:06.206Z",
    "updatedAt": "2025-07-16T17:29:06.206Z",
    "__v": 0
  },
  {
    "_id": "6878b7b26c53f97844022863",
    "id": "kaushik",
    "name": "Kaushik",
    "specialty": "Cardiology",
    "experience": "20 Yrs of Development",
    "image": "https://res.cloudinary.com/drpnp4uzc/image/upload/v1752741804/medical-linkers/doctors/mvtrupwdquqjegk4xjyv.jpg",
    "link": "/doctors/kaushik/",
    "description": "Veyr food doctor",
    "qualifications": [
      "B Tech",
      "AISSCE"
    ],
    "about": "Actually really good doctor",
    "hospital": "CohortLab",
    "country": "India",
    "categories": [
      "bestDoctors",
      "turkeyDoctors",
      "starDoctorsTurkeyData"
    ],
    "isActive": true,
    "createdAt": "2025-07-17T08:43:30.568Z",
    "updatedAt": "2025-07-17T08:43:30.568Z",
    "__v": 0
  },
  {
    "_id": "687a491266a25cf1732939ea",
    "id": "mithroghin-heim",
    "name": "Mithroghin Heim",
    "specialty": "Cardiology",
    "experience": "20 Yrs of Development",
    "image": "https://res.cloudinary.com/drpnp4uzc/image/upload/v1752844558/medical-linkers/doctors/agp08wranigdjadmwjoc.jpg",
    "link": "/doctors/mithroghin-heim/",
    "description": "kncebilkcrdj rjbcuhdncjdr vrjdcburchnidr",
    "qualifications": [
      "MBBS",
      "BTECH"
    ],
    "about": " bdcyrdjc rebcurevcerj vruvburvcvj rcjubce",
    "hospital": "FOrtis Bund",
    "country": "India",
    "categories": [
      "bestDoctors",
      "turkeyDoctors",
      "starDoctorsIndiaData",
      "starDoctorsTurkeyData"
    ],
    "isActive": true,
    "createdAt": "2025-07-18T13:16:02.747Z",
    "updatedAt": "2025-07-18T13:16:02.747Z",
    "__v": 0
  },
  {
    "_id": "687a5ec43a460260f698a314",
    "id": "mahab",
    "name": "Mahab",
    "specialty": "Neurology",
    "experience": "20 Yrs of Development",
    "image": "https://res.cloudinary.com/drpnp4uzc/image/upload/v1752850113/medical-linkers/doctors/qpldncpnql6sbqktzgyj.jpg",
    "link": "/doctors/mahab/",
    "description": "beyblunkec",
    "qualifications": [
      "MBBS",
      "BTECH"
    ],
    "about": "nviblnjncnciordjnco",
    "hospital": "Fortis Bund",
    "country": "Turkey",
    "categories": [
      "bestDoctors",
      "turkeyDoctors",
      "starDoctorsTurkeyData"
    ],
    "isActive": true,
    "createdAt": "2025-07-18T14:48:36.398Z",
    "updatedAt": "2025-07-18T14:48:36.398Z",
    "__v": 0
  },
  {
    "_id": "687a5ff93a460260f698a32c",
    "id": "nukwi",
    "name": "nukwi",
    "specialty": "Numerologu",
    "experience": "15 Yrs of Experience",
    "image": "https://res.cloudinary.com/drpnp4uzc/image/upload/v1752850422/medical-linkers/doctors/fv1ecnxkzdmoalnj0dql.jpg",
    "link": "/doctors/nukwi/",
    "description": "bveibjvebjbujevburrv beuevhrhvre vurvurvrj vburhvicrvn",
    "qualifications": "B Ed",
    "about": "ygceicbidbvur v ge7ge7 e7gce7g 9euv egce ce7cg7e",
    "hospital": "Fortis Abu Dhabi",
    "country": "India",
    "categories": [
      "bestDoctors",
      "starDoctorsIndiaData"
    ],
    "isActive": true,
    "createdAt": "2025-07-18T14:53:45.099Z",
    "updatedAt": "2025-07-18T14:53:45.099Z",
    "__v": 0
  },
  {
    "_id": "687a6800644a86c610ff62bb",
    "id": "sbnijj",
    "name": "Sbnijj",
    "specialty": "Neurology",
    "experience": "20 Yrs of Development",
    "image": "https://res.cloudinary.com/drpnp4uzc/image/upload/v1752852477/medical-linkers/doctors/umaqchv1spgbdu051odt.jpg",
    "link": "/doctors/sbnijj/",
    "description": "vcffgbh",
    "qualifications": [
      "MBBS",
      "BTECH"
    ],
    "about": " hjgvf",
    "hospital": "Fortis Bund",
    "country": "South Korea",
    "categories": [
      "bestDoctors"
    ],
    "isActive": true,
    "createdAt": "2025-07-18T15:28:00.442Z",
    "updatedAt": "2025-07-18T15:28:00.442Z",
    "__v": 0
  },
  {
    "_id": "687a9d345eec548bc8e569d7",
    "id": "bukai",
    "name": "Bukai",
    "specialty": "Neurology",
    "experience": "20 Yrs of Development",
    "image": "https://res.cloudinary.com/drpnp4uzc/image/upload/v1752866097/medical-linkers/doctors/dsxjnum5fpl9ommhbzsq.jpg",
    "link": "/doctors/bukai/",
    "description": ", wcevjkrgbdkacs, m",
    "qualifications": [
      "MBBS",
      "BTECH"
    ],
    "about": "r jfvbiudnkckenvrvhnjdvnjebucbesd",
    "hospital": "Fortis Korea",
    "country": "South Korea",
    "categories": [
      "bestDoctors",
      "starDoctorsSouthKoreaData"
    ],
    "isActive": true,
    "createdAt": "2025-07-18T19:15:00.455Z",
    "updatedAt": "2025-07-18T19:15:00.455Z",
    "__v": 0
  },
  {
    "_id": "687ab1410c90fd761b398548",
    "id": "xi-ping",
    "name": "Xi Ping",
    "specialty": "Neurology",
    "experience": "20 Yrs of Development",
    "image": "https://res.cloudinary.com/drpnp4uzc/image/upload/v1752871230/medical-linkers/doctors/qkuqmuyfqh9g63lddddi.jpg",
    "link": "/doctors/xi-ping/",
    "description": "xnbyitvyg uhnkajx",
    "qualifications": [
      "MBBS",
      "BTECH"
    ],
    "about": " kjabixbabcih chb usnx9u xubun",
    "hospital": "Apollo Korea",
    "country": "India",
    "categories": [
      "bestDoctors",
      "starDoctorsIndiaData"
    ],
    "isActive": true,
    "createdAt": "2025-07-18T20:40:33.616Z",
    "updatedAt": "2025-07-18T20:40:52.406Z",
    "__v": 0
  },
  {
    "_id": "687b4e405e64a53eb325ce62",
    "id": "xi-ping-ting",
    "name": "Xi Ping Ting",
    "specialty": "Neurology",
    "experience": "20 Yrs of Development",
    "image": "https://res.cloudinary.com/drpnp4uzc/image/upload/v1752911423/medical-linkers/doctors/rttbs44p34a3lanhu8sb.jpg",
    "link": "/doctors/xi-ping-ting/",
    "description": "yhtgfrghnthg5h jhthgth",
    "qualifications": [
      "MBBS",
      "BTECH"
    ],
    "about": "gfrbhntgynytgfrbgrfv",
    "hospital": "Apollo Delhi",
    "country": "South Korea",
    "categories": [
      "bestDoctors",
      "starDoctorsSouthKoreaData"
    ],
    "isActive": true,
    "createdAt": "2025-07-19T07:50:24.690Z",
    "updatedAt": "2025-07-19T07:51:11.325Z",
    "__v": 0
  },
  {
    "_id": "687b5771e630a5c672d50c58",
    "id": "lakshya",
    "name": "lakshya ",
    "specialty": " bj",
    "experience": "h",
    "image": "https://res.cloudinary.com/drpnp4uzc/image/upload/v1752913773/medical-linkers/doctors/ooilglu3xeovdyoftt6o.png",
    "link": "/doctors/lakshya/",
    "description": "wgycgugc",
    "qualifications": "mbbs",
    "about": "whbchch",
    "hospital": "Apollo Delhi",
    "country": "Thailand",
    "categories": [
      "bestDoctors"
    ],
    "isActive": true,
    "createdAt": "2025-07-19T08:29:37.655Z",
    "updatedAt": "2025-07-19T08:29:37.655Z",
    "__v": 0
  },
  {
    "_id": "687b62aee5444abb4f60e016",
    "id": "aditya-ranjan-3",
    "name": "Aditya Ranjan 3",
    "specialty": "Neurology",
    "experience": "20 Yrs of Development",
    "image": "https://res.cloudinary.com/drpnp4uzc/image/upload/v1752916652/medical-linkers/doctors/yioczf4ljnfl4laimsj0.jpg",
    "link": "/doctors/aditya-ranjan-3/",
    "description": "rtynm,.",
    "qualifications": [
      "MBBS",
      "BTECH"
    ],
    "about": "oiunbtvcrexwz",
    "hospital": "Fortis Thailand",
    "country": "Thailand",
    "categories": [
      "bestDoctors"
    ],
    "isActive": true,
    "createdAt": "2025-07-19T09:17:34.822Z",
    "updatedAt": "2025-07-19T09:24:42.832Z",
    "__v": 0
  }
];
